/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { WebApiAdminDtoBatchJobDetailDto } from './WebApiAdminDtoBatchJobDetailDto';
import {
    WebApiAdminDtoBatchJobDetailDtoFromJSON,
    WebApiAdminDtoBatchJobDetailDtoFromJSONTyped,
    WebApiAdminDtoBatchJobDetailDtoToJSON,
} from './WebApiAdminDtoBatchJobDetailDto';

/**
 * Batch jobs summary
 * @export
 * @interface WebApiAdminDtoBatchJobsSummaryDto
 */
export interface WebApiAdminDtoBatchJobsSummaryDto {
    /**
     * Total jobs created today
     * @type {number}
     * @memberof WebApiAdminDtoBatchJobsSummaryDto
     */
    totalJobsToday?: number;
    /**
     * Number of jobs waiting to be processed
     * @type {number}
     * @memberof WebApiAdminDtoBatchJobsSummaryDto
     */
    pendingJobs?: number;
    /**
     * Number of jobs currently being processed
     * @type {number}
     * @memberof WebApiAdminDtoBatchJobsSummaryDto
     */
    processingJobs?: number;
    /**
     * Number of jobs completed today
     * @type {number}
     * @memberof WebApiAdminDtoBatchJobsSummaryDto
     */
    completedJobsToday?: number;
    /**
     * Number of jobs failed today
     * @type {number}
     * @memberof WebApiAdminDtoBatchJobsSummaryDto
     */
    failedJobsToday?: number;
    /**
     * Recent failed jobs
     * @type {Array<WebApiAdminDtoBatchJobDetailDto>}
     * @memberof WebApiAdminDtoBatchJobsSummaryDto
     */
    recentFailedJobs?: Array<WebApiAdminDtoBatchJobDetailDto> | null;
    /**
     * Currently active jobs
     * @type {Array<WebApiAdminDtoBatchJobDetailDto>}
     * @memberof WebApiAdminDtoBatchJobsSummaryDto
     */
    activeJobs?: Array<WebApiAdminDtoBatchJobDetailDto> | null;
}

/**
 * Check if a given object implements the WebApiAdminDtoBatchJobsSummaryDto interface.
 */
export function instanceOfWebApiAdminDtoBatchJobsSummaryDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function WebApiAdminDtoBatchJobsSummaryDtoFromJSON(json: any): WebApiAdminDtoBatchJobsSummaryDto {
    return WebApiAdminDtoBatchJobsSummaryDtoFromJSONTyped(json, false);
}

export function WebApiAdminDtoBatchJobsSummaryDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): WebApiAdminDtoBatchJobsSummaryDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalJobsToday': !exists(json, 'totalJobsToday') ? undefined : json['totalJobsToday'],
        'pendingJobs': !exists(json, 'pendingJobs') ? undefined : json['pendingJobs'],
        'processingJobs': !exists(json, 'processingJobs') ? undefined : json['processingJobs'],
        'completedJobsToday': !exists(json, 'completedJobsToday') ? undefined : json['completedJobsToday'],
        'failedJobsToday': !exists(json, 'failedJobsToday') ? undefined : json['failedJobsToday'],
        'recentFailedJobs': !exists(json, 'recentFailedJobs') ? undefined : (json['recentFailedJobs'] === null ? null : (json['recentFailedJobs'] as Array<any>).map(WebApiAdminDtoBatchJobDetailDtoFromJSON)),
        'activeJobs': !exists(json, 'activeJobs') ? undefined : (json['activeJobs'] === null ? null : (json['activeJobs'] as Array<any>).map(WebApiAdminDtoBatchJobDetailDtoFromJSON)),
    };
}

export function WebApiAdminDtoBatchJobsSummaryDtoToJSON(value?: WebApiAdminDtoBatchJobsSummaryDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'totalJobsToday': value.totalJobsToday,
        'pendingJobs': value.pendingJobs,
        'processingJobs': value.processingJobs,
        'completedJobsToday': value.completedJobsToday,
        'failedJobsToday': value.failedJobsToday,
        'recentFailedJobs': value.recentFailedJobs === undefined ? undefined : (value.recentFailedJobs === null ? null : (value.recentFailedJobs as Array<any>).map(WebApiAdminDtoBatchJobDetailDtoToJSON)),
        'activeJobs': value.activeJobs === undefined ? undefined : (value.activeJobs === null ? null : (value.activeJobs as Array<any>).map(WebApiAdminDtoBatchJobDetailDtoToJSON)),
    };
}

